import { render } from "./PrivacyPolicyEep.vue?vue&type=template&id=3d3222a2"
import script from "./PrivacyPolicyEep.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyEep.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__